<app-button-modal title="Synchroniseer DHL labels" allowExit="true" class="sync-labels-modal">
    <div *ngIf="latestUploadStatus">
        <dl>
            <dd *ngIf="latestUploadStatus.isCompleted">Laatste import:</dd>
            <dd *ngIf="!latestUploadStatus.isCompleted">Huidige import:</dd>
            <dt>
                {{ latestUploadStatus.dateCreated | splitDate }} om
                {{ latestUploadStatus.dateCreated | splitTime }}
            </dt>
        </dl>
        <table *ngIf="latestUploadStatus" class="table">
            <thead class="thead-dark">
                <tr>
                    <th scope="col">Totaal</th>
                    <th scope="col">Succes</th>
                    <th scope="col">overgeslagen</th>
                    <th scope="col">Fouten</th>
                    <th scope="col">Resterend</th>
                    <th scope="col">Status</th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tr>
                <td>{{ latestUploadStatus.totalAmount }}</td>
                <td>{{ latestUploadStatus.successAmount }}</td>
                <td>{{ latestUploadStatus.skippedAmount }}</td>
                <td>{{ latestUploadStatus.erroredAmount }}</td>
                <td>
                    {{ getRemainingAmount(latestUploadStatus) }}
                </td>
                <td>
                    <span
                        class="badge"
                        [ngClass]="{
                            'bg-success': latestUploadStatus.status === UPLOAD_STATUSSES.DONE,
                            'bg-warning text-dark':
                                latestUploadStatus.status === UPLOAD_STATUSSES.STALLED,
                            'bg-primary': latestUploadStatus.status === UPLOAD_STATUSSES.WORKING,
                            'bg-danger': latestUploadStatus.status === UPLOAD_STATUSSES.ERROR,
                            'bg-danger': latestUploadStatus.status === UPLOAD_STATUSSES.CANCELLED
                        }"
                    >
                        {{ latestUploadStatus.status }}
                    </span>
                </td>
                <td>
                    <div class="d-flex gap-2">
                        <button
                            type="button"
                            class="btn btn-primary btn-sm mr-2"
                            title="Status verversen"
                            (click)="refreshSelectedStatus()"
                            [disabled]="isLoadingDetails"
                        >
                            <i class="fas fa-sync-alt" [class.fa-spin]="isLoadingDetails"></i>
                            Ververs
                        </button>

                        <button
                            *ngIf="!latestUploadStatus.isCompleted"
                            type="button"
                            class="btn btn-danger btn-sm"
                            title="Stoppen"
                            (click)="handleStopSync()"
                            [disabled]="isLoadingDetails"
                        >
                            <i class="fas fa-stop"></i> Stop Sync
                        </button>
                    </div>
                </td>
            </tr>
        </table>
    </div>

    <div *ngIf="!latestUploadStatus || latestUploadStatus.isCompleted">
        <div *ngIf="!csvIsParsed; else showData">
            <p>
                Voor een voorbeeld csv, zie hier het
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://my.dhlparcel.nl/business/#/v2/reporting/shipments"
                    >download csv</a
                >
                overzicht van DHL.
            </p>

            <p class="small text-muted">
                Het CSV bestand kan door komma's of door puntkomma's gescheiden worden.
            </p>
            <p class="small text-muted">
                Let Op!: De eerste rij van het CSV bestand bevat kolomkoppen. Deze rij wordt
                mogelijk overgeslagen bij de import.
            </p>
        </div>

        <ng-template #showData>
            <h5>Label(s) geïmporteerd: {{ labels.length }}</h5>
        </ng-template>

        <div *ngIf="validationErrors">
            <h3 class="error__title">Validatie fouten</h3>
            <div *ngFor="let error of validationErrors" class="error">
                <p class="error__detail">{{ error.fields[0] }}</p>
                <p class="error__detail">{{ error.reason }}</p>
            </div>
        </div>

        <form #packageForm="ngForm">
            <div class="buttons">
                <label (change)="changeListener($event)" class="btn btn-primary">
                    <span *ngIf="!fileName"
                        ><i class="fas fa-arrow-alt-from-bottom fa-lg"></i> KIES EEN BESTAND</span
                    >
                    <span *ngIf="fileName"
                        ><i class="fas fa-arrow-alt-from-bottom fa-lg"></i>{{ fileName }}</span
                    >
                    <input type="file" accept=".csv" value="" />
                </label>
                <button
                    *ngIf="csvIsParsed"
                    [disabled]="latestUploadStatus && !latestUploadStatus.isCompleted"
                    class="btn btn-primary"
                    type="submit"
                    (click)="buildInput()"
                >
                    Synchroniseer
                </button>
            </div>
        </form>
    </div>
</app-button-modal>
